import './main.less';
import groupBy from 'lodash/groupBy';
import GropedByCell from './GroupedByCell';
import Cell from './Cell';
import CommentCell from './CommentCell';

import React from 'react';

const Table = (props) => {
	const { table, setActiveRow, activeRowNumber, submitComment, getCommentsList, dropComment } = props;
	const { toggleUncoverByAdmin, toggleUncoverByAffiliate, uncoveredAffiliates, uncoveredAdmins } = props;
	const { rows, cols } = table;
	const affiliateOnlyRows = rows.filter(it => it.affiliate_id && !it.offer_id);

	return (
		<div className="traffic-accounting-wrap">
			<div className="table-container--projector__body">
				<div className="traffic-accounting-table">
					<div className="table_coll table_coll_main">
						<div className="table_cell top-row">Manager</div>
						{rows.map((row, index) =>
							<GropedByCell
								key={index} data={row} row_number={index} isGroupedByCol={true}
								setActiveRow={setActiveRow} activeRowNumber={activeRowNumber}
								toggleUncoverByAdmin={toggleUncoverByAdmin}
								toggleUncoverByAffiliate={toggleUncoverByAffiliate}
								uncoveredAdmins={uncoveredAdmins}
								affiliateRowId={getRowNumber(affiliateOnlyRows, row.admin, row.affiliate_id)}
								uncoveredAffiliates={uncoveredAffiliates}
							/>
						)}
					</div>
					<div className="scrolled_wrapper">
						{cols.map((column, index_col) => (
							<div className="table_coll date_coll" key={index_col}>
								<div className="table_cell top-row display-flex-column">
									<div className="top-row-date"><span>{ column }</span></div>
									<div className="display-flex">
										<div>Total</div>
										<div className="approved-number">Appr</div>
										<div className="">
											<span className="old">Apprv 3d prior</span>/<span className="new">Appr</span>
										</div>
									</div>
								</div>
								{
									rows.map((row, index) =>
										<Cell
											column={column}
											data={row}
											rows={rows}
											key={index}
											row_number={index}
											index={`${index_col}-${index}`}
											setActiveRow={setActiveRow}
											isToggledStartFrom10Approves={props.isToggledStartFrom10Approves}
											activeRowNumber={activeRowNumber}
										/>
									)
								}
							</div>
						))}
					</div>
					<div className="table_coll comments_coll">
						<div className="table_cell top-row">
							<p>Notes</p>
						</div>
						{
							rows.map((row, index) => (
								<CommentCell
									key={index}
									data={row}
									row_number={index}
									activeRowNumber={activeRowNumber}
									dropComment={dropComment}
									submitComment={submitComment}
									setActiveRow={setActiveRow}
									getCommentsList={getCommentsList}
								/>
							))
						}
					</div>
				</div>
			</div>
		</div>
	);
};

function getRowNumber(affiliateOnlyRows, admin, affiliate_id) {
	const groupedByAdmin = groupBy(affiliateOnlyRows, 'admin');
	return groupedByAdmin[admin]
		?	groupedByAdmin[admin].map(i => i.affiliate_id).indexOf(affiliate_id)
		: null;
}

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/traffic-accounting/components/table-drop/main.js